import { useMemo } from 'react';

import { useAuthSession } from '../useAuthSession';

/**
 * Custom hook to check if user is an Aampe admin
 * @returns boolean - True if user has admin flag AND @aampe.com email
 */
const useIsAampeAdmin = (): boolean => {
    const { user: currentUser } = useAuthSession();

    const isInternalAampeAdmin = useMemo(() => {
        if (!currentUser?.isInternalAampeAdmin) return false;

        const email = currentUser?.email?.toLowerCase() || '';
        return email.endsWith('@aampe.com');
    }, [currentUser]);

    return isInternalAampeAdmin;
};

export default useIsAampeAdmin;
